import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_field'])) {
            can('manage', 'FIELD')
            can('manage', 'DiarioOs', {
                area: 'FIELD'
            })
            can('manage', 'EapOS', {
                area: 'FIELD'
            });
            return build()
        }

        if (user.temPermissao(['field_config'])) {
            can('config', 'FIELD', {
                area: 'FIELD'
            });
        }

        if (user.temPermissao(['field'])) {
            can('read', 'FIELD');
            can('create', 'FIELD');
            can('create', 'OS_FIELD');
            can('create', 'DiarioOs', {
                area: 'FIELD'
            });
            can('create', 'DiarioOs', {
                area: 'POS'
            });
            can('create', 'EapOS', {
                area: 'FIELD'
            });
            can('create', 'EapOS', {
                area: 'POS'
            });
        }

        if (user.temPermissao(['site_manager'])) {
            can(['create', 'read'], 'OS_FIELD');
        }
    }

    return build()
}